module.exports = __webpack_public_path__ + "static/media/date-helper.0027d0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/date-helper/date-helper.png
// module id = 36
// module chunks = 0